import { FormattedMessage } from 'react-intl';

import { reactSelectComponents } from '../reactSelectComponents';

import { texts } from '../Select.text';

export const NoOptionsMessage = (props: any) => {
  return (
    <reactSelectComponents.NoOptionsMessage {...props}>
      {props.children === 'No options' ? (
        <FormattedMessage {...texts.noOptionsMessage} />
      ) : (
        props.children
      )}
    </reactSelectComponents.NoOptionsMessage>
  );
};
